import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state from './state'

export const SHARED_TEMPLATES_NAMESPACE = 'sharedTemplates'

export const SharedTemplates = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
